import { CensusGeo } from 'src/app/modules/research/model/census.geo';
import { BuildingType } from './enums/building.type';

export class Location {
  ID: string;
  PRIMARY: boolean;
  ADDRESS: string;
  CITY: string;
  STATE: string;
  ZIP: string;
  OWNERSHIP_TYPE: string; // OWNED / LEASED
  OWNED_BY: string; // OWNER / COMPANY / HOLDING
  FAIR_MARKET_RENT: number;
  RE_LEASE_BEGIN: string;
  RE_LEASE_END: string;
  RE_LEASE_RENEW_OPTION: boolean;
  RE_LEASE_RENEW: number;
  RE_LEASE_RENT: number;
  TOTAL_SQFT: number;
  TOTAL_LEASE_OVER_10_YRS: boolean;
  TOTAL_LEASE_YRS: number;
  BUILDING_TYPE: BuildingType;
  ORDER: number;
  LEASE_MOTMO: boolean;
  EFFECTIVE_DATE: Date;
  NON_LOCATION_SPECIFIC: boolean;
  CENSUS: CensusGeo;

  constructor(value: any = {}) {
    Object.assign(this, value);
    if(value.CENSUS)
      this.CENSUS = new CensusGeo(value.CENSUS);
  }

  static parseArray(json: any[]): Location[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new Location(j));
        }
      }
    }

    return arr;
  }
}
